import { ValidationFailureResponse } from "@/shared/interfaces/validation-error.interface";

export default function isValidationFailureResponse(data: unknown): data is ValidationFailureResponse {
  return (
    typeof data === "object" &&
    data !== null &&
    "success" in data &&
    data.success === false &&
    "errors" in data &&
    Array.isArray(data.errors)
  );
}
